module.exports = __webpack_public_path__ + "img/github.ec3a60c8.png";